import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * logout(){
  try{
     const api = yield call([axios, axios.post], '/api/user/logout')
     yield put({type:'REQUEST_LOGOUT_SUCCESS'});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getMeAsync(){
  try{
    const api = yield call([axios, axios.get], '/api/me')
    yield put({type:'REQUEST_GET_ME_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_LOGOUT_SUCCESS'});
  }
}

function * wizardCompletedAsync(data){
  try{
       const api = yield call([axios, axios.post], '/api/wizard_completed', {type:data.wizard_type})
       console.log(api, 'APPII');
       yield put({type:'REQUEST_WIZARD_COMPLETED_SUCCESS', val:api.data})
     }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response});};
    ;
}

function * resendForgotPasswordEmailAsync(data){
  try{

       const api = yield call([axios, axios.post], '/api/forgot/password/email', data.payload)
      }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}yield put({type:'REQUEST_RESEND_FORGOT_PASSWORD_EMAIL_SUCCESS'});
}

function * resetPasswordAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/forgot/password/reset', data.payload)
     yield put({type:'REQUEST_RESET_PASSWORD_SUCCESS'});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * resendVerificationEmailAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/user/emailVerification/resend', data.payload)
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'VERIFICATION_EMAIL_ERROR'});
  }
}

function * updateUserAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/user/update', data.payload)
     yield put({type:'REQUEST_UPDATE_USER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updatePasswordAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/user/update/password', data.payload)
     yield put({type:'REQUEST_UPDATE_PASSWORD_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateEmailAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/user/update/email', data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * indexSubscriptionsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/subscriptions',data.payload);
     yield put({type:'REQUEST_INDEX_SUBSCRIPTIONS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexEnumerationsAsync(){
  try{
     const api = yield call([axios, axios.get], '/api/config/enumerations');
     yield put({type:'REQUEST_INDEX_ENUMERATIONS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexAccountTextAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/accountText', data.payload);
     yield put({type:'REQUEST_INDEX_ACCOUNT_TEXT_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * updateAccountTextAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/accountText', data.payload);
     yield put({type:'REQUEST_UPDATE_ACCOUNT_TEXT_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateLastUrlAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/updateLastUrl', {last_url:data.url});
     yield put({type:'REQUEST_UPDATE_LAST_URL_SUCCESS', val:data.url});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexNotificationsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/notifications');
     yield put({type:'REQUEST_INDEX_NOTIFICATIONS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getCallManagerAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/call_manager');
     yield put({type:'REQUEST_GET_CALL_MANAGER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function* getSearchToolDefaultsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/search_tool_defaults');
     yield put({type:'REQUEST_GET_SEARCH_TOOL_DEFAULTS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexSavedMappingsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/saved_mappings');
     yield put({type:'REQUEST_INDEX_SAVED_MAPPINGS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexCsvUploadsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/uploads/batches/csv_uploads');
     yield put({type:'REQUEST_INDEX_CSV_UPLOADS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * saveMappingsAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/saved_mappings', data.payload);
     yield put({type:'REQUEST_SAVE_MAPPINGS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getCreditMenuAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/credits/menu')
    yield put({type:'REQUEST_GET_CREDIT_MENU_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');}
}

function* indexMessageTypesAsync() {
  try {
    const api = yield call([axios, axios.get], '/api/message_types')
    yield put({ type: 'REQUEST_INDEX_MESSAGE_TYPES_SUCCESS', message_types: api.data });
  } catch (error) { console.log(error, 'ERROR'); }
}


function* Get_credit_menu(){yield takeEvery('REQUEST_GET_CREDIT_MENU', getCreditMenuAsync);}



function* Index_notifications(){yield takeEvery('REQUEST_INDEX_NOTIFICATIONS', indexNotificationsAsync);}

function* Index_enumerations(){yield takeEvery('REQUEST_INDEX_ENUMERATIONS', indexEnumerationsAsync);}
function* Index_account_text(){yield takeEvery('REQUEST_INDEX_ACCOUNT_TEXT', indexAccountTextAsync);}
function* Update_account_text(){yield takeEvery('REQUEST_UPDATE_ACCOUNT_TEXT', updateAccountTextAsync);}

function* Index_subscriptions(){yield takeEvery('REQUEST_INDEX_SUBSCRIPTIONS', indexSubscriptionsAsync);}
function* Update_user(){yield takeEvery('REQUEST_UPDATE_USER', updateUserAsync);}
function* Update_email(){yield takeEvery('REQUEST_UPDATE_EMAIL', updateEmailAsync);}
function* Update_password(){yield takeEvery('REQUEST_UPDATE_PASSWORD', updatePasswordAsync);}

function* Reset_password(){yield takeEvery('REQUEST_RESET_PASSWORD', resetPasswordAsync);}
function* Resend_forgot_password_email(){yield takeEvery('REQUEST_RESEND_FORGOT_PASSWORD_EMAIL', resendForgotPasswordEmailAsync);}
function* Resend_verification_email(){yield takeEvery('REQUEST_RESEND_VERIFICATION_EMAIL', resendVerificationEmailAsync);}
function* Get_me(){yield takeEvery('REQUEST_GET_ME', getMeAsync);}
function* Logout(){yield takeEvery('REQUEST_LOGOUT', logout);}

function* Wizard_completed(){yield takeEvery('REQUEST_WIZARD_COMPLETED', wizardCompletedAsync);}

function* Update_last_url(){yield takeEvery('REQUEST_UPDATE_LAST_URL', updateLastUrlAsync);}
function* Get_call_manager(){yield takeEvery('REQUEST_GET_CALL_MANAGER', getCallManagerAsync);}
function* Get_search_tool_defaults(){yield takeEvery('REQUEST_GET_SEARCH_TOOL_DEFAULTS', getSearchToolDefaultsAsync);}
function* Index_saved_mappings(){yield takeEvery('REQUEST_INDEX_SAVED_MAPPINGS', indexSavedMappingsAsync);}
function* Save_mappings(){yield takeEvery('REQUEST_SAVE_MAPPINGS', saveMappingsAsync);}
function* Index_csv_uploads(){yield takeEvery('REQUEST_INDEX_CSV_UPLOADS', indexCsvUploadsAsync);}
function* Index_message_types(){yield takeEvery('REQUEST_INDEX_MESSAGE_TYPES', indexMessageTypesAsync);}

export default function* Root_lists(){
  yield all([
    fork(Wizard_completed),
    fork(Update_user),
    fork(Update_email),
    fork(Update_password),
    fork(Reset_password),
    fork(Resend_forgot_password_email),
    fork(Resend_verification_email),
    fork(Index_notifications),
    fork(Get_me),
    fork(Index_message_types),
    fork(Logout),
    fork(Index_subscriptions),
    fork(Index_account_text),
    fork(Index_enumerations),
    fork(Update_account_text),
    fork(Update_last_url),
    fork(Get_call_manager),
    fork(Get_search_tool_defaults),
    fork(Index_saved_mappings),
    fork(Save_mappings),
    fork(Index_csv_uploads),
    fork(Get_credit_menu)
  ])}
